import { cssVar } from 'metrix-common3';

const DeleteIcon = () => (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 24 24' fill='none'>
        <path
            stroke={cssVar.colorError}
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth='2'
            d='M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6h14zM10 11v6m4-6v6'
        />
    </svg>
);

export default DeleteIcon;
